<template>
  <!--Apps slider container-->
  <div class="apps-container text-center">
    <button>
      <i class="fa fa-plus"></i>
    </button>
    <div class>
      <div class="col-sm-3 float-left">
        <div class="app">
          <img src="../../assets/images/sentio-logo.png">
        </div>
      </div>
      <div class="col-sm-3 float-left">
        <div class="app">
          <img src="../../assets/images/PO-logo.png">
        </div>
      </div>
      <div class="col-sm-3 float-left">
        <div class="app">
          <img src="../../assets/images/PO-logo.png">
        </div>
      </div>
      <div class="col-sm-3 float-left">
        <div class="app">
          <img src="../../assets/images/PO-logo.png">
        </div>
      </div>
      <div class="col-sm-3 float-left">
        <div class="app">
          <img src="../../assets/images/PO-logo.png">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppCardComponent"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.apps-container {
  position: absolute;
  top: calc(100vh - 2.5rem); /* fallback if css var is not supported*/
  top: calc(calc(var(--vh, 1vh) * 100) - 2.5rem);
  background: #fff;
  width: 100%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}
.apps-container.opened {
  top: calc(100vh - 202px); /* fallback if css var is not supported*/
  top: calc(calc(var(--vh, 1vh) * 100) - 202px);
}
.apps-container.opened button i.fa-plus:before {
  content: "\f068";
}
.apps-container button {
  background: transparent;
  border: none;
  font-size: 1.7rem;
  color: #c6c6c6;
}
.apps-container button:focus {
  outline: none;
}
</style>